import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import ConnectDomruPopupGroup from '~/src/components/ConnectDomruPopup/ConnectDomruPopupGroup';
import UnauthDesktopHeader from '~/src/features/_layout/Header/desktop/components/UnauthDesktopHeader';
import UnauthMobileHeader from '~/src/features/_layout/Header/mobile/UnauthMobileHeader';
import { IUnauthHeaderProps } from '~/src/features/_layout/Header/types';
import { isLeadGenerationHide } from '~/src/helpers/isLeadGenerationHide';
import { selectUnauthMenu } from '~/src/store/selectors/menu/selectMenu';

export const UnauthHeader = () => {
    const newMenuItems = useSelector(selectUnauthMenu);
    const { asPath } = useRouter();
    const [showBecomeClientPopup, setShowBecomeClientPopup] = useState(false);
    const sendAuthEvent = useCallback((action = 'Войти в личный кабинет') => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.mainMenuClick,
            action,
            label: 'menu_new',
        });
    }, []);
    const openBecomeClientPopup = useCallback(() => {
        sendAuthEvent('Подключить Дом.ру');
        setShowBecomeClientPopup(true);
    }, []);

    const hasPhoneInfo = !isLeadGenerationHide();
    const referrerPath = `?referrer=${decodeURIComponent(asPath)}`;

    const props: IUnauthHeaderProps = {
        hasPhoneInfo,
        items: newMenuItems,
        onBecomeClientHandler: openBecomeClientPopup,
        referrerPath,
    };

    return (
        <>
            <UnauthMobileHeader {...props}/>
            <UnauthDesktopHeader {...props}/>
            <ConnectDomruPopupGroup
                showBecomeClientPopup={showBecomeClientPopup}
                closeBecomeClientPopup={() => setShowBecomeClientPopup(false)}
            />
        </>
    );
};
